// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const MOONSHOTAI_CN_MODELS = {
	"kimi-k2-0711-preview": {
		id: "kimi-k2-0711-preview",
		name: "Kimi K2 0711",
		api: "openai-completions",
		provider: "moonshotai-cn",
		baseUrl: "https://api.moonshot.cn/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"thinkingFormat":"deepseek"},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.6,
			output: 2.5,
			cacheRead: 0.15,
			cacheWrite: 0,
		},
		contextWindow: 131072,
		maxTokens: 16384,
	} satisfies Model<"openai-completions">,
	"kimi-k2-0905-preview": {
		id: "kimi-k2-0905-preview",
		name: "Kimi K2 0905",
		api: "openai-completions",
		provider: "moonshotai-cn",
		baseUrl: "https://api.moonshot.cn/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"thinkingFormat":"deepseek"},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 0.6,
			output: 2.5,
			cacheRead: 0.15,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
	"kimi-k2-thinking": {
		id: "kimi-k2-thinking",
		name: "Kimi K2 Thinking",
		api: "openai-completions",
		provider: "moonshotai-cn",
		baseUrl: "https://api.moonshot.cn/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"thinkingFormat":"deepseek"},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.6,
			output: 2.5,
			cacheRead: 0.15,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
	"kimi-k2-thinking-turbo": {
		id: "kimi-k2-thinking-turbo",
		name: "Kimi K2 Thinking Turbo",
		api: "openai-completions",
		provider: "moonshotai-cn",
		baseUrl: "https://api.moonshot.cn/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"thinkingFormat":"deepseek"},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.15,
			output: 8,
			cacheRead: 0.15,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
	"kimi-k2-turbo-preview": {
		id: "kimi-k2-turbo-preview",
		name: "Kimi K2 Turbo",
		api: "openai-completions",
		provider: "moonshotai-cn",
		baseUrl: "https://api.moonshot.cn/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"thinkingFormat":"deepseek"},
		reasoning: false,
		input: ["text"],
		cost: {
			input: 2.4,
			output: 10,
			cacheRead: 0.6,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
	"kimi-k2.5": {
		id: "kimi-k2.5",
		name: "Kimi K2.5",
		api: "openai-completions",
		provider: "moonshotai-cn",
		baseUrl: "https://api.moonshot.cn/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"thinkingFormat":"deepseek"},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.6,
			output: 3,
			cacheRead: 0.1,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
	"kimi-k2.6": {
		id: "kimi-k2.6",
		name: "Kimi K2.6",
		api: "openai-completions",
		provider: "moonshotai-cn",
		baseUrl: "https://api.moonshot.cn/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"thinkingFormat":"deepseek"},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.95,
			output: 4,
			cacheRead: 0.16,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
	"kimi-k2.7-code": {
		id: "kimi-k2.7-code",
		name: "Kimi K2.7 Code",
		api: "openai-completions",
		provider: "moonshotai-cn",
		baseUrl: "https://api.moonshot.cn/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"thinkingFormat":"deepseek"},
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 0.95,
			output: 4,
			cacheRead: 0.19,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
	"kimi-k2.7-code-highspeed": {
		id: "kimi-k2.7-code-highspeed",
		name: "Kimi K2.7 Code HighSpeed",
		api: "openai-completions",
		provider: "moonshotai-cn",
		baseUrl: "https://api.moonshot.cn/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"thinkingFormat":"deepseek"},
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 1.9,
			output: 8,
			cacheRead: 0.38,
			cacheWrite: 0,
		},
		contextWindow: 262144,
		maxTokens: 262144,
	} satisfies Model<"openai-completions">,
	"kimi-k3": {
		id: "kimi-k3",
		name: "Kimi K3",
		api: "openai-completions",
		provider: "moonshotai-cn",
		baseUrl: "https://api.moonshot.cn/v1",
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false,"maxTokensField":"max_tokens","supportsStrictMode":false,"thinkingFormat":"deepseek","requiresReasoningContentOnAssistantMessages":true,"deferredToolsMode":"kimi"},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":null,"low":null,"medium":null,"high":null,"xhigh":null,"max":"max"},
		input: ["text", "image"],
		cost: {
			input: 3,
			output: 15,
			cacheRead: 0.3,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 131072,
	} satisfies Model<"openai-completions">,
} as const;
